import axios from "axios";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Game } from "speakid-horse-race";
import 'speakid-horse-race/style.css';
import Config from "../../Config";
import PersonalDefaultPage from "../personal/PersonalDefaultPage";
import { useI18n } from "../../i18n/I18nProvider";

// -----------------------------
// Error Boundary (локальный)
// -----------------------------
function ErrorFallback() {
  const { t } = useI18n();
  return (
    <div style={{ padding: 40, textAlign: "center" }}>
      <h2>{t("Что-то пошло не так")}</h2>
      <p>{t("Не удалось загрузить игру.")}</p>
    </div>
  );
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) return <ErrorFallback />;
    return this.props.children;
  }
}

// -----------------------------
// Основной компонент
// -----------------------------
export default function HorseRace() {
  const navigate = useNavigate();

  // URL к ассетам /cloud/
  const baseURL =
    typeof window !== "undefined"
      ? window.origin + "/cloud/speakid/games/horse-race/"
      : "";

  // Проверка подписки
  useEffect(() => {
    axios
      .get(Config.BACKEND_ADDR + "/payments/getSubscriptionPeriod")
      .then((res) => {
        if (res.status === 200 && res.data.status === "not_paid") {
          navigate("/billing/");
        }
      })
      .catch(() => {});
  }, [navigate]);

  return (
    <PersonalDefaultPage>
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          overflow: "hidden",
          zIndex: 0,
        }}
      >
        <ErrorBoundary>
          <Game 
            baseURL={baseURL}
            showLogo={true}
          />
        </ErrorBoundary>
      </div>
    </PersonalDefaultPage>
  );
}
